import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import tokens from '@verifime/design-tokens';
import { ColoredIcon, useEntityColor } from './ColoredIconAndChip';
import { EntityStatus } from '@verifime/utils';

function CredentialStatusChip({ withCredential }: { withCredential: boolean }) {
  const verifiedColor = useEntityColor(EntityStatus.Verified);
  const errorColor = useEntityColor(EntityStatus.Rejected);
  const color = withCredential ? verifiedColor : errorColor;
  
  return (
    <ColoredIcon
      iconName={withCredential ? 'checkRounded' : 'warningAmberRounded'}
      statusColor={color}
      role="img"
      aria-hidden={false}
      aria-label={withCredential ? 'has credential' : 'no credential'}
      isCompact={true}
    />
  );
}

function credentialStatusTooltipText(withCredential: boolean) {
  return withCredential
    ? 'Client portal access: Enabled'
    : 'Client portal access: Disabled due to missing credentials';
}

export default function UserCredentialStatus({ withCredential }: { withCredential: boolean }) {
  return (
    <Tooltip
      title={<Box padding={tokens.spacing2xs}>{credentialStatusTooltipText(withCredential)}</Box>}
      describeChild
      placement="top"
    >
      {/* 
      By default, the tooltip do not trigger user interactions for non-interactive elements, so a Tooltip will not activate on normal events like hover. 
      To accommodate disabled elements, add a simple wrapper element, such as a span. See https://mui.com/material-ui/react-tooltip/#disabled-elements. 

      In addition, the identifier (data-component) must go on the visible, interactive child element, e.g. the span here, instead of the Tooltip wrapper.
      */}
      <Box component="span" data-component="user-credential-status">
        <CredentialStatusChip withCredential={withCredential} />
      </Box>
    </Tooltip>
  );
}
